import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <section className="pcoded-main-container page_404">
      <div className="pcoded-wrapper container">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <div className="row">
                  <div className="col-sm-12 ">
                    <div className="col-sm-offset-1 text-center">
                      <h1
                        className="text-center"
                        style={{ marginBottom: '100px' }}
                      >
                        404
                      </h1>
                      <div className="four_zero_four_bg"></div>

                      <div className="contant_box_404">
                        <h3 className="h2">{t('page-not-found-title')}</h3>

                        <p>{t('page-not-found-messages')}</p>

                        <Link to="/" className="link_404">
                          {t('page-not-found-button')}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
